export const READ_SINGLE_NOTIFICATION_ENDPOINT = '/clientteling/Read-One-Notifications';
